import { Meta } from '@storybook/addon-docs';
import { TokensGrid } from '../../components/TokensGrid';
import { fonts } from '@rocketseat-ignite-ui/tokens';

<Meta title='Tokens/Font Families' />

# Font Families

<TokensGrid tokens={fonts} />
